import type { RendererProps } from "../core/element-registry"
import { ElementRenderer } from "./element-renderer"
import { FieldGroup } from "../components/ui/field"
import { cn } from "../lib/utils"

export function FieldGroupRenderer({ element }: RendererProps) {
  return (
    <FieldGroup
      className={cn(element.className)}
      data-testid={`field-group-${element.id}`}
    >
      {element.children?.map((child) => (
        <ElementRenderer key={child.id} element={child} />
      ))}
    </FieldGroup>
  )
}
